import { DrawerSection } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import { DetailField } from '../shared/index.js';

/** Confidence tone: green ≥ 0.85, amber 0.65–0.85, coral < 0.65. */
function confidenceToneClass(score) {
  if (score >= 0.85) return 'text-emerald-500';
  if (score >= 0.65) return 'text-amber-500';
  return 'text-rose-500';
}

/**
 * Situation block for HTL / Client Continuation: why the agent paused, the
 * workflow / agent / model it was running, its GE classification, and the
 * confidence score called out as a headline figure like the prototype.
 */
function SituationBlock({ detail, situation }) {
  const { t } = useTranslation('work-queues-app');
  if (!detail) return null;

  const rows = [
    { label: t('continuation.workflow'), value: detail.workflow },
    { label: t('continuation.agent'), value: detail.agent },
    { label: t('continuation.model'), value: detail.model },
  ].filter((row) => row.value);

  return (
    <DrawerSection title={t('detail.situation')}>
      <div className="flex flex-col gap-4">
        {situation ? (
          <p className="text-sm leading-relaxed text-content-secondary">{situation}</p>
        ) : null}

        {rows.length > 0 ? (
          <dl className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {rows.map((row) => (
              <DetailField key={row.label} label={row.label} value={row.value} />
            ))}
          </dl>
        ) : null}

        {detail.geClassification ? (
          <dl>
            <DetailField
              label={t('continuation.geClassification')}
              value={detail.geClassification}
            />
          </dl>
        ) : null}

        {typeof detail.confidence === 'number' ? (
          <p className="flex items-baseline gap-2">
            <span
              className={`text-2xl font-semibold leading-none ${confidenceToneClass(detail.confidence)}`}
            >
              {`${Math.round(detail.confidence * 100)}%`}
            </span>
            <span className="text-xs text-content-faint">{t('continuation.confidenceLabel')}</span>
          </p>
        ) : null}
      </div>
    </DrawerSection>
  );
}

export default SituationBlock;
